export default __webpack_public_path__ + "static/media/TRUCK7.1e006039.jpg";